const Data = [
  {
    id: 4,
    title: "Coarse Graining Transition Matrix",
    summary: "Read more",
    readmore: false,
    path: "/transition_matrix",
    image: require("./2023-project-1/coarse.png"),
  },
  {
    id: 3,
    title: "Investigating Cell Fate Trajectories",
    summary: "",
    path: "/project1",
    image: require("./2023-project-3/cellTrajectory.gif"),
  },
  {
    id: 2,
    title:
      "Modelling the Open Probability of Ion Channels on Cell/Organelle's Membrane",
    summary: "",
    path: "./2023-project-1/example",
    image: require("./2023-project-1/training_evolution.gif"),
  },
  {
    id: 1,
    title:
      "Testing the Efficacy of Cytosine Base Editors for making Targeted Mutations in the Integrator Complex",
    summary: "",
    path: "./2023-project-1/example",
    image: require("./2023-project-1/Abel_Gurung_SMART_presentation.jpg"),
  },
];

export default Data;
